var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dynameat-row',{attrs:{"title":_vm.saleZone.name,"buttonConfigList":_vm.buttonConfigList,"isClickable":false},on:{"preview-qrcode":_vm.onPreviewQRCode,"download-qrcode":_vm.onDownloadQRCode}})}
var staticRenderFns = []

export { render, staticRenderFns }